module.exports = __webpack_public_path__ + "img/channel.a345b511.png";